import CustomTimePicker from "./TimePicker";
import DatePickerComponent from "./date-picker.component";
import { formats as FORMATS } from "../../config/constants";
import moment from "moment";

export default function DateTimePicker(vnode) {
  let date = vnode.attrs.value?.date || "";
  let time = vnode.attrs.value?.time || "12:00";
  let required = vnode.attrs.required || false;

  const update = () => {
    vnode.attrs.onchange?.({
      date,
      time,
      datetime: date && time ? `${date} ${time}` : "",
    });
  };

  return {
    view(vnode) {
      return m(".d-flex.align-items-center.gap-2", [
        m("div",
          { style: { "max-width": "210px", "z-index": 9999 } },
          m(DatePickerComponent, {
            id: vnode.attrs.id,
            class: 'form-control',
            isRange: false,
            required: required,
            date: date ? moment(date).format(FORMATS.dateFormat) : "",
            minDate: moment().format(FORMATS.dateFormat),
            onselect: (e) => {
              date = moment(e.detail.date).format(FORMATS.dateFormat);
              update();
            }
          })),
        m(CustomTimePicker, {
          required: required,
          onchange: (t) => {
            time = t;
            update();
          },
        }),
      ]);
    },
  };
}